import loadable from '@loadable/component';
import { loadableOptions } from '@utils/helpers';

const Onboarding = {
  Profile: loadable(() => import('./Profile'), loadableOptions),
};

export default Onboarding;
